import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import AgentRegistrationAPI from './pages/AgentRegistrationAPI';
import WebRTCClient from './pages/WebRTCClient';
import AgentRegistrationProcess from './pages/AgentRegistrationProcess';
import Autodialer from './pages/Autodialer';
import ConverseFlows from './pages/ConverseFlows';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/docs/agent-registration-api" element={<AgentRegistrationAPI />} />
        <Route path="/docs/webrtc-client" element={<WebRTCClient />} />
        <Route path="/docs/agent-registration" element={<AgentRegistrationProcess />} />
        <Route path="/docs/autodialer" element={<Autodialer />} />
        <Route path="/docs/converse-flows" element={<ConverseFlows />} />
        <Route path="/" element={<Home />} />
      </Routes>
    </Router>
  );
}

export default App;
